<template>
    <div id="custom-online">
        <Breadcrumb></Breadcrumb>
        <el-row style="text-align: right">
            <el-button type="warning"  size="mini">保存到待发布</el-button>
            <el-button type="success"  size="mini">立即发布</el-button>
        </el-row>
        <el-form :model="form" :label-position="labelPosition" ref="form" label-width="100px" :rules="rules" id="form" style="margin-top: 20px">
            <!--产品信息-->
            <el-container>
                <el-header class="headerBorder" style="height: 40px">产品信息</el-header>
                <el-main class="main">
                    <el-form-item label="中文标题:" style="margin-top: 20px" prop="name_1">
                        <el-input v-model="form.name" class="inputSize" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="英文标题:" style="margin-top: 20px">
                        <el-input v-model="form.name_2" class="inputSize" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="产品分类" style="margin-top: 20px" prop="name_3">
                        <el-input v-model="form.name_3" class="inputSize" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="生产工艺" style="margin-top: 20px" prop="name_4">
                        <el-input v-model="form.name_4" class="inputSize" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="产品材质" style="margin-top: 20px" prop="name_5">
                        <el-select clearable  v-model="form.name_5" placeholder="请选择" size="mini" class="inputSize">
                            <el-option
                                    v-for="item in options_1"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生产天数" style="margin-top: 20px" prop="name_6">
                        <el-select clearable  v-model="form.name_6" placeholder="请选择" size="mini" class="inputSize">
                            <el-option
                                    v-for="item in options_2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-main>
            </el-container>
            <!--SKU信息-->
            <el-container class="container">
                <el-header class="headerBorder" style="height: 40px">SKU信息</el-header>
                <el-main class="main">
                    <el-row>
                        <span>生成变种</span>
                    </el-row>
                    <el-row v-for="(item,index) in form.attributList" style="margin-top: 10px">
                        <el-col :span="1" style="text-align: right">
                            <i class="el-icon-remove-outline" style="font-size: 20px;margin-right: 10px;color: #66b1ff;cursor: pointer" @click="deleteAttrName(index)"></i>
                        </el-col>
                        <el-col :span="4" style="text-align: right">
                            <el-input
                                    @blur="handleName(index)"
                                    v-model.trim="item.attributeName"
                                    size="mini" placeholder="属性名,如:Color"
                                    style="width: 200px;margin-right: 15px"
                                    onkeyup="this.value=this.value.replace(/[\s]/g, '');"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <!--标签-->
                            <el-tag
                                    :key="tag"
                                    v-for="tag in item.dynamicTags"
                                    closable
                                    :disable-transitions="false"
                                    @close="handleClose(tag,index)">
                                {{tag}}
                            </el-tag>
                            <el-input
                                    class="input-new-tag"
                                    v-if="item.inputVisible"
                                    v-model.trim="item.attributeValue"
                                    ref="saveTagInput"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm(index)"
                                    @blur="handleInputConfirm(index)"
                                    onkeyup="this.value=this.value.replace(/[\s]/g, '');"
                            >
                            </el-input>
                            <el-button v-else class="button-new-tag" size="small" @click="showInput(index)">+添加新属性值</el-button>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 10px">
                            <span>
                                 <el-link type="primary" @click="addAttribute">+添加新属性</el-link>
                            </span>
                    </el-row>
                    <el-row style="margin-top: 10px">
                            <span>
                                编辑变种
                            </span>
                    </el-row>
                    <div style="margin-top: 10px">
                        <el-table id="table" ref="multipleTable" :data="form.tableData"
                                  style="width: 100%" @selection-change="handleSelectionChange" v-show="form.tableData.length>0">
                            <!--<el-table-column type="selection" width="40" align="center"></el-table-column>-->
                            <el-table-column prop="picUrl" label="图片"  align="center">
                                <template slot-scope="scope">
                                    <!--http-request如果想处理额外参数,则在方法里面再调用方法-->
                                    <el-upload
                                            :show-file-list="false"
                                            class="upload-demo"
                                            action="#"
                                            multiple
                                            :http-request="function (res) { return handleParam(res, scope.$index)}">
                                        <div v-show="scope.row.picUrl==''">
                                            <i class="el-icon-plus" style="font-size: 25px"></i>
                                        </div>
                                        <img v-show="scope.row.picUrl!=''" style="width: 80px" :src="scope.row.picUrl" />
                                    </el-upload>
                                </template>
                            </el-table-column>
                            <el-table-column prop="varAttr" label="变种信息" align="center">
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px" >
                                        <span>{{scope.row.varAttr}}</span>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="SKU"  align="center">
                                <template slot="header" slot-scope="scope">
                                    <el-row>SKU</el-row>
                                    <el-row>
                                        <el-button type="text" @click="updateSkuDig=true">(一键生成)</el-button>
                                    </el-row>
                                </template>
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px"  :prop="'tableData.'+scope.$index+'.commSku'"   :rules='rules.commSku'>
                                        <el-input size="mini" v-model.trim="scope.row.commSku" placeholder="请输入内容"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="价格"  align="center">
                                <template slot="header" slot-scope="scope">
                                    <el-row>价格</el-row>
                                    <el-row>
                                        <el-button type="text" @click="updatePriceDig = true">(修改)</el-button>
                                    </el-row>
                                </template>
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px" :prop="'tableData.'+scope.$index+'.price'"   :rules='rules.price'>
                                        <el-input size="mini" v-model.trim="scope.row.price" placeholder="请输入内容" ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="操作"  align="center">
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px">
                                        <el-link type="primary" @click="deleteAttr(scope.row,scope.$index)">移除</el-link>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-main>
            </el-container>
            <!--变种图片-->
            <el-container class="container">
                <el-header class="headerBorder" style="height: 40px">变种图片</el-header>
                <el-main class="main">
                    <div style="text-align: center" v-show="form.tableData.length<1">暂无图片</div>
                    <div v-for="(item, index) in form.tableData">
                        <el-row>
                            <el-upload
                                    :show-file-list="false"
                                    class="upload-demo"
                                    action="#"
                                    multiple
                                    :http-request="function (res) { return skuUploadImg(res,index)}"
                                    v-show="item.skuPicList.length<5">
                                <el-link type="primary">点击上传图片</el-link>
                            </el-upload>
                        </el-row>
                        <!--商品信息说明-->
                        <div>
                            <el-row style="text-align: center">
                                <span v-for="(attr, index) in form.attributList"  style="margin-right: 15px">{{attr.attributeName}}:{{item.attrList[index]}}</span>
                                <div style="margin-right: 15px">【{{item.skuPicList.length}}/5】图片</div>
                            </el-row>
                        </div>
                        <!--图片-->
                        <div>
                            <el-row>
                                <el-col :span="2" v-for="(item_2, img_index) in item.skuPicList" :key="img_index" style="margin-right: 20px">
                                    <el-card :body-style="{ padding: '5px'}">
                                        <el-popover trigger="hover" title="" placement="right">
                                            <img :src="item_2.imgUrl" style="width: 200px;height: 200px">
                                            <img slot="reference" :src="item_2.imgUrl" class="image">
                                        </el-popover>
                                        <div style="padding: 5px;">
                                            <el-row style="font-size: 5px">
                                                <el-link style="font-size: 5px;float: left">{{item_2.picPx}}</el-link>
                                                <el-link type="primary"style="font-size: 5px;float: right" @click="deleteSkuImg(index,img_index)">移除</el-link>
                                            </el-row>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                        <el-divider></el-divider>
                    </div>
                </el-main>
            </el-container>
            <!--设计图片-->
            <el-container class="container">
                <el-header class="headerBorder" style="height: 40px">设计图片</el-header>
                <el-main class="main">
                    <div>
                        <!---->
                        <!--图片-->
                        <div id="cardStyle">
                            <el-row>
                                <el-col  v-for="(item_2, img_index) in 1"  style="margin-right: 20px;width: 130px">
                                    <el-card :body-style="{ padding: '5px'}">
                                        <div style="text-align:center;padding: 5px;font-size:15px ">
                                            设计覆盖图
                                        </div>
                                        <div v-show="form.design.imgUrl != null && form.design.imgUrl !=''">
                                            <el-popover trigger="hover" title="" placement="right" >
                                                <img :src="form.design.imgUrl" style="width: 200px;height: 200px">
                                                <img slot="reference" :src="form.design.imgUrl" style="width: 120px;display: block;height: 100px;">
                                            </el-popover>
                                        </div>
                                        <el-upload
                                                :show-file-list="false"
                                                class="upload-demo"
                                                action="#"
                                                multiple
                                                list-type="picture-card"
                                                :http-request="function (res) { return designUploadImg(res)}"
                                                v-show="form.design.imgUrl == null ||form.design.imgUrl ==''">
                                            <i class="el-icon-plus" style="font-size: 70px"></i>
                                        </el-upload>
                                        <div style="padding: 5px;" v-show="form.design.imgUrl != null && form.design.imgUrl !=''">
                                            <el-row>
                                                <el-link style="font-size: 13px;float: left">1200x1200</el-link>
                                                <el-link type="primary"style="font-size: 13px;float: right" @click="deleteDesignImg">移除</el-link>
                                            </el-row>
                                        </div>

                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-main>
            </el-container>
            <!--包装信息-->
            <el-container class="container">
                <el-header class="headerBorder" style="height: 40px">包装信息</el-header>
                <el-main class="main">
                    <el-form-item label="重量:" prop="packWeight" style="margin-top: 15px">
                        <el-input
                                onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                                v-model="form.packWeight"
                                style="width: 200px"
                                size="small">
                            <template slot="append">KG</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="包装尺寸:">
                        <el-input
                                @input="limitNumber($event,'long')"
                                onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                v-model="form.packLong"
                                style="width: 200px"
                                size="small">
                            <template slot="append">CM</template>
                        </el-input>
                        <el-input
                                @input="limitNumber($event,'wide')"
                                onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                v-model="form.packWide"
                                style="width: 200px;margin-left: 20px"
                                size="small">
                            <template slot="append">CM</template>
                        </el-input>
                        <el-input
                                @input="limitNumber($event,'high')"
                                onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                v-model="form.packHigh"
                                style="width: 200px;margin-left: 20px"
                                size="small">
                            <template slot="append">CM</template>
                        </el-input>
                    </el-form-item>
                </el-main>
            </el-container>
            <!--描述信息-->
            <el-container class="container">
                <el-header class="headerBorder" style="height: 40px">描述信息</el-header>
                <el-main class="main">
                    <el-row>
                        <span>
                             产品描述：
                        </span>
                        <span style="color: red;margin-left: 30px">
                            说明：描述区图片尺寸需小于5000x5000，图片大小不能超过3M!
                        </span>
                    </el-row>
                    <div style="margin-top: 25px;margin-bottom: 25px">
                        <CKEditor4 v-model="form.description" @getCkEditorInstance="getEditor1" :config="editorConfig"></CKEditor4>
                    </div>
                    <el-row>
                        产品尺寸:
                    </el-row>
                    <div style="margin-bottom: 20px">
                        <CKEditor4 v-model="form.size" @getCkEditorInstance="getEditor2" :config="editorConfig"></CKEditor4>
                    </div>
                    <el-form-item label-width="80px" label="设计提示:">
                        <el-input v-model="form.designTip" placeholder="请输入内容" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="温馨提示:">
                        <el-input type="textarea" :rows="5" v-model="form.warmTip" placeholder="请输入内容" size="mini"></el-input>
                    </el-form-item>

                </el-main>
            </el-container>
            <!--一键生成SKU弹框弹框-->
            <el-dialog :close-on-click-modal="false"  
                    title="修改价格"
                    :visible.sync="updateSkuDig"
                    width="30%"
                    
                    @close="cancelPrice">
                <el-row style="margin-top: 15px;margin-left: 15px">
                    <el-form-item label-width="80px" label="前缀" >
                        <el-input v-model.trim="prefixSku"  placeholder="请输入内容" size="mini" style="width: 200px"></el-input>
                        <!--<el-input v-model.trim="prefixSku" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);" placeholder="请输入内容" size="mini" style="width: 200px"></el-input>-->
                    </el-form-item>
                    <el-form-item label-width="80px" label="后缀" >
                        <el-input v-model.trim="suffixSku"  placeholder="请输入内容" size="mini" style="width: 200px"> </el-input>
                    </el-form-item>
                    <span>
                        说明：前缀=BG0001,后缀=CN,生成：BG0001-CN
                    </span>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancelPrice" size="small">取 消</el-button>
                <el-button type="primary" @click="sumbitSku" size="small">确 定</el-button>
            </span>
            </el-dialog>
            <!--修改价格弹框-->
            <el-dialog :close-on-click-modal="false"  
                    title="修改价格"
                    :visible.sync="updatePriceDig"
                    width="30%"
                    
                    @close="cancelPrice">
                <el-row style="margin-top: 15px;margin-left: 15px">
                    <el-form-item label-width="80px" label="价格" >
                        <el-input v-model.trim="price" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');" placeholder="请输入内容" size="mini" style="width: 200px"></el-input>
                    </el-form-item>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancelPrice" size="small">取 消</el-button>
                <el-button type="primary" @click="sumbitSku" size="small">确 定</el-button>
            </span>
            </el-dialog>
        </el-form>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import ElRow from "element-ui/packages/row/src/row";
    import {calcDescartes,toDecimal} from '@/utils/jn';
    import {goodsUploadImg} from '@/api/product/common';
    import CKEditor4 from '@/components/common/CKEditor'
    export default {
        name: "product",
        components:{
            ElRow,
            Breadcrumb,
            CKEditor4
        },
        data(){
            return{
                labelPosition: 'right',
                form:{
                    name_1:'',
                    name_2:'',
                    name_3:'',
                    name_4:'',
                    name_5:'',
                    name_6:'',
                    name_7:'',
                    name_8:'',
                    tableData:[
                        // {
                        //     varAttr:null,
                        //     picUrl:null,
                        //     commSku:null,
                        //     price:null,
                        //     skuPicList:[
                        //         {
                        //            imgUrl:'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        //         },
                        //         {
                        //             imgUrl:'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        //         }
                        //     ],
                        // },
                    ],
                    attributList: [
                        // {
                        //     attributeName:null,
                        //     attributeValue:null,
                        //     dynamicTags: ['标签一', '标签二', '标签三'],
                        //     inputVisible: false,
                        // },
                        // {
                        //     attributeName:null,
                        //     attributeValue:null,
                        //     dynamicTags: ['标签一', '标签二', '标签三'],
                        //     inputVisible: false,
                        // }
                    ],
                    design:{
                        imgUrl:null,
                        picPx:null,
                    },
                    packWeight:null, //重量
                    packLong:null,   //长
                    packWide:null,   //宽
                    packHigh:null,   //高
                    description:null, //产品描述
                    size:null, //产品尺寸
                    designTip:null, //设计提示
                    warmTip:null, //温馨提示
                },
                updateSkuDig:false, //一键生成SKU弹框
                prefixSku:null, //SKU前缀
                suffixSku:null, //SKU后缀
                updatePriceDig:false,//修改价格弹框
                price:null,//价格
                rules: {
                    name_1: [
                        {required: true, message: '请输入中文标题', trigger: 'blur'},
                    ],
                    name_2: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                    ],
                    name_3: [
                        {required: true, message: '请输入产品分类', trigger: 'blur'},
                    ],
                    name_4: [
                        {required: true, message: '请输入生产工艺', trigger: 'blur'},
                    ],
                    name_5: [
                        {required: true, message: '请输入产品材质', trigger: 'blur'},
                    ],
                    name_6: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                    ],
                    name_7: [
                        {required: true, message: '请输入生产天数', trigger: 'blur'},
                    ],
                    price: [
                        { required: true, message: '请输入价格', trigger: 'blur' },
                    ],
                    typeId: [
                        { required: true, message: '请选择商品分类', trigger: 'blur' },
                    ],
                    commSku: [
                        { required: true, message: '请输入SKU', trigger: 'blur' },
                    ],
                },
                //产品材质
                options_1: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                //生产天数
                options_2: [{
                        value: '选项1',
                        label: '1-3天'
                    }, {
                        value: '选项2',
                        label: '3-5天'
                    }, {
                        value: '选项3',
                        label: '5-7天'
                    }, {
                        value: '选项4',
                        label: '大于7天'
                    },
                ],
                //描述文本框
                editor1:null,
                editor2:null,
                editorConfig:{
                    // extraPlugins:'myplug',
                    height:'300px',
                    toolbar : [
                        [ 'Source','Maximize'],
                        [ 'Bold', 'Italic', 'Underline', 'Strike'],
                        [ 'TextColor', 'BGColor' ],
                        [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                        [ 'HorizontalRule','RemoveFormat'],
                        ['NewPage', 'Preview', '-', 'Undo', 'Redo' ],
                        '/',
                        [ 'Styles', 'Format', 'Font', 'FontSize' ],
                        [ 'Paste', 'PasteText', 'PasteFromWord','Table'],
                        [ 'Link', 'Unlink','-' ,'Image']
                    ],
                    language: 'zh-cn',
                    wordcount:{
                        showCharCount: true,
                    }

                },
            }
        },
        methods:{
            deleteAttrName(index){
                this.form.attributList.splice(index,1);
                this.loadSku();
            },
            handleInputConfirm(index) {
                var attributeName = this.form.attributList[index].attributeName;
                if (attributeName==null || attributeName.replace(/[\s]/g, '')==''){
                    this.msgError("属性名不能为空");
                    this.inputHide(index);
                    return
                }
                //获取input的值
                var inputValue = this.form.attributList[index].attributeValue;
                if (inputValue==null || inputValue.replace(/[\s]/g, '')==''){
                    this.inputHide(index);
                    return
                }
                //获取标签集合
                var dynamicTags = this.form.attributList[index].dynamicTags;
                //是否包含这个值
                let b = dynamicTags.includes(inputValue);
                if (b && inputValue){
                    this.msgError(inputValue+"已存在");
                    this.inputHide(index);
                    return
                }
                if (inputValue) {
                    this.form.attributList[index].dynamicTags.push(inputValue)
                }
                this.loadSku();
                this.inputHide(index);
            },
            showInput(index) {
                this.$set(this.form.attributList[index], 'inputVisible', true)
                // this.inputVisible = true;
                this.$nextTick(_ => {
                    let saveTagInput = this.$refs.saveTagInput[0];
                    this.$refs.saveTagInput[0].focus();
                });
            },
            addAttribute(){
                for (var i=0 ; i<this.form.attributList.length;i++){
                    if (this.form.attributList[i].attributeName==null || this.form.attributList[i].attributeName==' '){
                        this.msgError("请先填写新增的属性,再添加下一个");
                        return
                    }
                    if (this.form.attributList[i].dynamicTags.length <=0){
                        this.msgError("请先填写属性值,再添加下一个");
                        return
                    }
                }
                this.form.attributList.push(
                    {
                        attributeName:null,
                        attributeValue:null,
                        dynamicTags: [],
                        inputVisible: false,
                        inputValue: '',
                    }
                )
            },
            //覆盖默认上传行为
            handleParam(data,index){
                this.uploadByPicType(data,index)
            },
            //上传图片时,区分不同的图片类型参数
            uploadByPicType(data,index){
                var formData = new FormData();
                //文件
                formData.append("imageFile", data.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.$set(this.form.tableData[index], 'picUrl', res.data.img);
                        for (var i=0; i<this.form.tableData.length; i++){
                            if(this.form.tableData[i].picUrl=='' || this.form.tableData[i].picUrl==null){
                                this.$set(this.form.tableData[i], 'picUrl', res.data.img);
                            }
                        }
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //移除属性
            deleteAttr(row,index){
                //删除表格的一条数据
                this.form.tableData.splice(index,1);
                //获取sku
                let commSku = row.commSku;
                //分割数组
                var commSkuList = commSku.split("-");
                //遍历数组
                for (var i=0; i<commSkuList.length; i++){
                    //取出对应的属性值
                    var commSku2 = commSkuList[i];
                    //定义好是否需要删除属性值的标志
                    var flag=false;
                    for (var j=0; j<this.form.tableData.length; j++){
                        //取出SKU
                        var commSku3 = this.form.tableData[j].commSku;
                        //分割成数组
                        var split = commSku3.split("-");
                        //取出i对应的索引
                        let split2 = split[i];
                        if (split2==commSku2){
                            flag=true;
                        }
                    }
                    if (!flag){
                        //获取对应的属性名
                        let attributList = this.form.attributList[i];
                        //取出属性值集合
                        let dynamicTags = attributList.dynamicTags;
                        //遍历属性值,如果有对应的则删除掉,因为表格里已经没有数据了
                        for (var i2=0; i2<dynamicTags.length; i2++){
                            if (commSku2==attributList.dynamicTags[i2]){
                                this.form.attributList[i].dynamicTags.splice(i2,1);
                            }
                        }
                    }
                }
            },
            //表格checkbox选择
            handleSelectionChange(){

            },
            getEditor1(val){
                this.editor1 = val;
            },
            getEditor2(val){
                this.editor2 = val;
            },
            //清空属性名时提示的操作
            handleName(index){
                var attributeName = this.form.attributList[index].attributeName;
                var dynamicTags = this.form.attributList[index].dynamicTags
                if(attributeName==null || attributeName==""){
                    if (dynamicTags.length > 0){
                        this.$confirm('清空属性值会清空所有的属性名,你确定要清空吗', "警告", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(function() {
                            return true;
                        }).then(() => {
                            this.$set(this.form.attributList[index], 'dynamicTags', []);
                            this.loadSku();
                            this.msgSuccess("清空成功");
                        }).catch(function() {});
                    }

                }

            },
            //动态增删SKU
            loadSku(){
                this.form.tableData=[];
                var attributList = this.form.attributList;
                //如果有多个则遍历添加
                var cartesianArray=[];
                for (var i=0; i<attributList.length; i++){
                    //获取标签的集合
                    var dynamicTags2 = this.form.attributList[i].dynamicTags;
                    // attributeName+=this.form.attributList[i].attributeName+"*";
                    cartesianArray.push(dynamicTags2);
                }
                var calcDescartes2 = calcDescartes(cartesianArray);
                //变种信息
                var attributeName='';
                // 商品SKU
                var value ="";
                for (var i=0; i<calcDescartes2.length; i++){
                    //判断是不是数组
                    if (calcDescartes2[i].constructor==Array){
                        value = calcDescartes2[i].join("-");
                        attributeName = calcDescartes2[i].join("*");
                    }else {
                        value = calcDescartes2[i];
                        attributeName = calcDescartes2[i];
                    }
                    this.addTable(attributeName,value,calcDescartes2[i]);
                }
            },
            //往表格添加一条数据
            addTable(name,value,calcDescartes2){
                this.form.tableData.push(
                    {
                        varAttr:name,
                        picUrl:'',
                        commSku:value,
                        price:'',
                        skuPicList:[
                            // {
                            //     imgUrl:'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                            // },
                            // {
                            //     imgUrl:'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                            // }
                        ],
                        attrList:calcDescartes2,
                    }
                )
            },
            //隐藏输入框并把值=''
            inputHide(index){
                this.$set(this.form.attributList[index], 'inputVisible', false)
                this.$set(this.form.attributList[index], 'attributeValue', '')
            },
            //取消修改
            cancelPrice(){
                this.updateSkuDig = false;
                this.updatePriceDig = false;
                this.prefixSku = null;
                this.suffixSku = null;
                this.price = null;
            },
            //提交修改SKU
            sumbitSku(){
                let prefixSku = this.prefixSku;
                let suffixSku = this.suffixSku;
                if (prefixSku==null || prefixSku==""){
                    this.msgError("前缀不能为空");
                    return
                }
                if (suffixSku==null || suffixSku==""){
                    this.msgError("后缀不能为空");
                    return
                }
                var sku = prefixSku+"-"+suffixSku;
                for (var i=0; i<this.form.tableData.length; i++){
                    this.form.tableData[i].commSku=sku;
                }
                this.cancelPrice();
            },
            //提交价格
            sumbitSku(){
                let price = this.price;
                if (price==null || price==""){
                    this.msgError("价格不能为空");
                    return
                }
                let number = toDecimal(price);
                for (var i=0; i<this.form.tableData.length; i++){
                    this.form.tableData[i].price=number;
                }
                this.cancelPrice();
            },
            //包装尺寸的检验
            limitNumber(e,name){

                if (e!=null && e>100000){
                    if (name=='long'){
                        this.bzyys.formLabelAlign.packLong=100000
                    }else if (name=='wide'){
                        this.bzyys.formLabelAlign.packWide=100000

                    }else if (name=='high'){
                        this.bzyys.formLabelAlign.packHigh=100000
                    }
                }
            },
            //变种图片的上传图片
            skuUploadImg(res,index){
                var formData = new FormData();
                //文件
                formData.append("imageFile", res.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.form.tableData[index].skuPicList.push(
                            {
                                imgUrl:res.data.img,
                                picPx:res.data.picPx
                            }
                        )
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //删除SKU图片
            deleteSkuImg(tableIndex,imgIndex){
                this.form.tableData[tableIndex].skuPicList.splice(imgIndex,1);
            },
            //删除设计图片
            deleteDesignImg(){
                this.form.design.imgUrl =null;
                this.form.design.picPx =null;
            },
            //上传设计图片
            designUploadImg(res){
                var formData = new FormData();
                //文件
                formData.append("imageFile", res.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.form.design.imgUrl=res.data.img
                        this.form.design.picPx=res.data.picPx
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            }
        }
    }
</script>

<style scoped>
    .headerBorder{
        border:1px solid darkgrey;
    }
    .container{
        margin-top: 15px;
    }
    .main{
        border:1px solid darkgrey;
        border-top: none;
        width: 100%;
    }
    .el-header{
        height: 40px;
    }
    .inputSize{
        width: 300px;
    }
    .image {
        width: 88px;
        display: block;
        height: 100px;
    }


</style>
<style>
    #cardStyle .el-upload--picture-card {
        width: 115px;
        height: 100px;
    }

</style>
